import { render, staticRenderFns } from "./RemocaoPrevPagRebo.vue?vue&type=template&id=19984e21"
import script from "./RemocaoPrevPagRebo.vue?vue&type=script&lang=js"
export * from "./RemocaoPrevPagRebo.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports